import { render, staticRenderFns } from "./CreateDossierView.vue?vue&type=template&id=3479b97d&scoped=true"
import script from "./CreateDossierView.vue?vue&type=script&lang=ts"
export * from "./CreateDossierView.vue?vue&type=script&lang=ts"
import style0 from "./CreateDossierView.vue?vue&type=style&index=0&id=3479b97d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479b97d",
  null
  
)

export default component.exports